import type { IconSvgObject } from './types';

const MoveIcon: IconSvgObject = [
  ["path", { d: "M12 9.00006V3.74997M9.5 5.5L12 3.00006L14.5 5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 14.5001V20.32M14.5 18.5L12 21.0001L9.5 18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 12.0001H20.3121M18.5 9.5L21 12.0001L18.5 14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M9 12.0001H3.62365M5.5 14.5L3 12.0001L5.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MoveIcon;
